<template>
  <input
    v-if="type == 'percentage'"
    class="InputPercentage"
    :class="inputClasses"
    :disabled="disabled"
    @keypress="onKeyPress"
    @paste="onPaste"
    v-on:keyup="updateCommission"
    v-model="display"
  />
  <input
    v-else-if="type == 'currency'"
    class="InputCurrency"
    :class="inputClasses"
    :disabled="disabled"
    @keypress="onKeyPress"
    @paste="onPaste"
    v-on:keyup="updateCommission"
    v-model="display"
  />
  <currency-input
    v-else
    v-on:keyup="updateCommission"
    v-model="ValueMapper"
    :class="inputClasses"
    :disabled="disabled"
  />
</template>

<script>
export default {
  name: "decimal-field",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    inputClass: {
      type: String,
      default: ""
    },
    maxDecimalPlaces: {
      type: Number,
      default: 2
    },
    type: {
      type: String,
      default: 'percentage' // or currency
    },
    value: {
      type: Number,
      default: 0.00
    }
  },
  data: function() {
    return {
      display: null,
    };
  },
  model: {
    event: `modified`
  },
  methods: {
    updateCommission(state) {
      const paymentMethod = state.srcElement.id;
      this.updateCommissionValue(state, paymentMethod);
    },
    updateCommissionValue(state, paymentMethod) {
      const commissionCompetences = this.$store.getters.CommissionCompetence;

      const taxList = [];
      const commissionsList = [];
      for (const method of commissionCompetences[paymentMethod].Taxes) {
        taxList.push(method.Tax);
        commissionsList.push(method.Commission);
      }

      const newValue = parseFloat(state.target.value.replace(",", "."));
      let commission = commissionsList[0];
      for (let i = 0;  i < taxList.length; i++){
        const numberOfTaxes = commissionCompetences[paymentMethod].Taxes.length;
        const highestTax = commissionCompetences[paymentMethod].Taxes[numberOfTaxes - 1].Tax;
        if (newValue == highestTax) {
          commission = commissionsList[commissionsList.length - 1];
          break ;
        }
        if (newValue >= taxList[i]) {
          commission = commissionsList[i];
          continue ;
        }
      }

      const PAYMENT_METHOD = paymentMethod.toUpperCase();

      const isLink = state.srcElement.className.includes("link");
      if (isLink) {
        if (newValue < taxList[0]) {
          this.$store.commit("SET_LINK_" + PAYMENT_METHOD + "_COMMISSION", commissionsList[0]);
        } else if (newValue > taxList[taxList.length - 1]) {
          this.$store.commit("SET_LINK_" + PAYMENT_METHOD + "_COMMISSION", commissionsList[commissionsList.length - 1]);
        } else {
          this.$store.commit("SET_LINK_" + PAYMENT_METHOD + "_COMMISSION", commission);
        }
        return ;
      }

      const isCalc = state.srcElement.className.includes("calc");
      if (isCalc) {
        if (newValue < taxList[0]) {
          this.$store.commit("SET_CALC_" + PAYMENT_METHOD + "_COMMISSION", commissionsList[0]);
        } else if (newValue > taxList[taxList.length - 1]) {
          this.$store.commit("SET_CALC_" + PAYMENT_METHOD + "_COMMISSION", commissionsList[commissionsList.length - 1]);
        } else {
          this.$store.commit("SET_CALC_" + PAYMENT_METHOD + "_COMMISSION", commission);
        }
        return ;
      }

      const taxInfo = this.$store.getters.TaxInfo;
      if (taxInfo != null) {
        if (newValue < taxList[0]) {
          this.$store.commit("SET_" + PAYMENT_METHOD + "_COMMISSION", commissionsList[0]);
        } else if (newValue > taxList[taxList.length - 1]) {
          this.$store.commit("SET_" + PAYMENT_METHOD + "_COMMISSION", commissionsList[commissionsList.length - 1]);
        } else {
          this.$store.commit("SET_" + PAYMENT_METHOD + "_COMMISSION", commission);
        }
        return ;
      } else {
        if (newValue < taxList[0]) {
          this.$store.commit("SET_MERCHANTPREVIEW_" + PAYMENT_METHOD + "_COMMISSION", commissionsList[0])
        } else if (newValue > taxList[taxList.length - 1]) {
          this.$store.commit("SET_MERCHANTPREVIEW_" + PAYMENT_METHOD + "_COMMISSION", commissionsList[commissionsList.length - 1])
        } else {
          this.$store.commit("SET_MERCHANTPREVIEW_" + PAYMENT_METHOD + "_COMMISSION", commission)
        }
        return ;
      }
    },
    changeValue(newValue) {
      this.$emit("modified", newValue);
      this.$emit("onchange", newValue);
    },
    onFocusOut(ev) {
      this.$emit("onfocusout", ev);
    },
    onKeyPress(ev) {
      const codeIsNumber = /^[0-9]$/i.test(ev.key);
      const codeIsComma = (ev.code == 'Comma' || ev.code == 'NumpadDecimal')? true : false;
      if ( !codeIsNumber && !codeIsComma) {
        ev.preventDefault();
      } else {
        const isComma = (this.display.includes(',') || this.display.includes('.'));
        const hasComma = this.display == null ? false : isComma;
        if (codeIsComma && hasComma) {
          ev.preventDefault();
          return ;
        }

        if (codeIsNumber && hasComma) {
          const delimeter = this.display.includes('.') ? '.' : ',';
          const numDecimalPlace = this.display.split(delimeter)[1].length;
          const target = ev.target;

          let isSelected = false;
          if (target.selectionEnd - target.selectionStart >= 1) {
            isSelected = true;
          }

          if (numDecimalPlace >= this.maxDecimalPlaces && !isSelected) {
            ev.preventDefault();
          }

          if (delimeter == '.') {
            const newValue = target.value.replace(/\./g, ',');
            target.value = newValue;
          }
        }
      }
    },
    onPaste(ev) {
      ev.preventDefault();

      let pasteData = ev.clipboardData.getData('text/plain');
      let onlyNumberAndComma = pasteData.replace(/[^\d,]/gm, '');
      let split = onlyNumberAndComma.split(',');

      let newValue = split[1] != null ? split[0] + ',' + split[1] : split[0];

      if (split[1] != null && split[1].length > 2) {
        let replacedComma = newValue.replace(/,/gm, '.');
        let valFloat = parseFloat(replacedComma).toFixed(2);
        this.display = valFloat.replace(/\./gm, ',');

      } else {
        this.display = newValue;
      }

    },
  },
  mounted() {
    if (this.value != null) {
      if (this.type == 'percentage' || this.type == 'currency') {
        const fixedValue = parseFloat(Math.round(this.value * 100) / 100).toFixed(2);
        const result = fixedValue.replace(/\./gm, ',');
        this.display = result;
      }
    }
  },
  computed: {
    inputClasses() {
      return this.inputClass + " form-control";
    },
    ValueMapper: {
      get() {
        return this.value;
      },
      set(value) {
        this.changeValue(value);
      }
    }
  },
  watch: {
    display: function() {
      if (this.display.includes(",")) {
        const value = this.display.replace(/,/gm, ".");
        if (value == '.') {
          this.changeValue(0.0);
          return;
        }
        this.changeValue(parseFloat(value));
        return;
      }

      if (this.display.includes(".")) {
        if (this.display.startsWith(".")) {
          this.changeValue(0.0);
          return;
        }
        this.changeValue(parseFloat(this.display));
        return;
      }

      if (this.display.length > 0) {
        this.changeValue(parseFloat(this.display));
        return;
      }

      this.changeValue(0.0);
    },
    disabled: function(newValue, oldValue) {
      if (newValue != null) {
        if (newValue == false && oldValue == true) {
          this.display = this.display.replace(/%/gm, '');
        }
      }
    },
    type: function(newValue, oldValue) {
      if (newValue == 'percentage' && oldValue == 'currency') {
        let value = parseFloat(Math.round(this.value * 100) / 100).toFixed(2);
        this.display = value.replace(/\./gm, ',');
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/decimal-field.vue